import { Component } from "react";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../utils.css";
import { setDisplayOnlyIfGotCerfa, setSelectedTechnicianId } from "../../redux/intervention/interventionSortAndFilter";
import Switch from "@mui/material/Switch";
import MenuItem from "@mui/material/MenuItem";
import { ALL_SELECT_OPTION } from "../../constants";
import { FormControl, InputLabel } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";

class WorkOrdersFilters extends Component {
	setDisplayOnlyIfGotCerfa() {
		this.props.setDisplayOnlyIfGotCerfa(!this.props.interventionsFilters.displayOnlyIfGotCerfa);
	}

	setSelectedTechnician(e) {
		this.props.setSelectedTechnicianId(e.target.value);
	}

	getTechnicianRows() {
		let technicianRows = [];
		let distinctTechnicians = [];

		technicianRows.push(
			<MenuItem key={"none"} value={ALL_SELECT_OPTION}>
				{"Tous"}
			</MenuItem>
		);

		for (let otIndex = 0; otIndex < this.props.allWorkOrders.length; otIndex++) {
			let currentWorkOrder = this.props.allWorkOrders[otIndex];

			let currentTechnicians = currentWorkOrder.technicians.split(", ");

			currentTechnicians.forEach((currentTechnician) => {
				if (distinctTechnicians.find((t) => t === currentTechnician)) return;

				distinctTechnicians.push(currentTechnician);
			});
		}

		distinctTechnicians.sort().forEach((technician, index) => {
			technicianRows.push(
				<MenuItem key={index} value={technician}>
					{technician}
				</MenuItem>
			);
		});

		return technicianRows;
	}

	render() {
		return (
			<Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin filters-card without-side-padding">
				<CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
					<div className="row without-side-padding switch-label">
						<div className="offset-lg-2 col-lg-3 col-md-3 col-sm-2 col-3 right span-center-verticaly without-side-padding">
							<span
								className={
									!this.props.interventionsFilters.displayOnlyIfGotCerfa ? "selected-label" : ""
								}
							>
								Toutes
							</span>
						</div>
						<div className="col-lg-2 col-md-2 col-sm-4 col-4 without-side-padding">
							<Switch
								onChange={this.setDisplayOnlyIfGotCerfa.bind(this)}
								checked={this.props.interventionsFilters.displayOnlyIfGotCerfa}
								className="switch"
								color="secondary"
							/>
						</div>
						<div className="col-lg-5 col-md-5 col-sm-5 col-5 without-side-padding span-center-verticaly">
							<span
								className={
									this.props.interventionsFilters.displayOnlyIfGotCerfa ? "selected-label" : ""
								}
							>
								Avec fiche cerfa
							</span>
						</div>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
						<FormControl className="row">
							<InputLabel id="technician-label">Technicien</InputLabel>
							<CustomizedSelect
								labelId="technician-label"
								id="technician"
								placeholder="Technicien"
								className="full_size"
								label="Technicien"
								onChange={this.setSelectedTechnician.bind(this)}
																value={this.props.interventionsFilters.selectedTechnicianId}
							>
								{this.getTechnicianRows()}
							</CustomizedSelect>
						</FormControl>
					</div>
				</CardContent>
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		interventionsFilters: state.interventions,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setDisplayOnlyIfGotCerfa: (displayOnlyIfGotCerfa) => dispatch(setDisplayOnlyIfGotCerfa(displayOnlyIfGotCerfa)),
		setSelectedTechnicianId: (technicianId) => dispatch(setSelectedTechnicianId(technicianId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrdersFilters);
